// Feature 012: one planned slot with alternative versions, shown as a single card in its calendar
// slot (instead of one draft per version). Presentational: the board passes the group and onOpen.
import React from "react";
import {format} from "date-fns";
import {getHandlerIconByCode} from "../../helpers/functions";
import {VariantGroupType} from "../../redux/Content/VariantGroup/types";
import {cardState, groupDate, pickProgress} from "./VariantGroupCard.helpers";
import {PeerActivityModeCode} from "../../redux/Content/PeerActivityMode/types";

type Translate = (key: string, defaultValue?: string) => string;

interface Props {
    group: VariantGroupType;
    t: Translate;
    onOpen?: (group: VariantGroupType) => void;
    compact?: boolean;
}

const VariantGroupCard: React.FC<Props> = ({group, t, onOpen, compact = false}) => {
    const state = cardState(group);
    const start = groupDate(group);
    const {picked, total} = pickProgress(group);

    return (
        <button
            type="button"
            className={"variantGroupCard variantGroupCard--" + state + (compact ? " variantGroupCard--compact" : "")}
            data-state={state}
            onClick={(e) => {
                e.stopPropagation();
                onOpen?.(group);
            }}
            title={group.title}
        >
            <span className="variantGroupCard__head">
                {start && <span className="variantGroupCard__time">{format(start, "HH:mm")}</span>}
                <span className="variantGroupCard__badge">
                    <i className="ri-git-branch-line" aria-hidden="true"/> {group.variants.length} {t("variantGroup:versions", "versions")}
                </span>
                {group.mode && group.mode.code !== PeerActivityModeCode.ACTIVITY &&
                    <span className="variantGroupCard__kind">{t("peerActivityMode:" + group.mode.code, group.mode.code)}</span>}
                <span className={"variantGroupCard__state variantGroupCard__state--" + state}>{t("variantGroup:state_" + state, state)}</span>
            </span>
            <span className="variantGroupCard__title text-truncate">{group.title}</span>
            {!compact &&
                <span className="variantGroupCard__foot">
                    <span className="variantGroupCard__channels">
                        {group.targets.slice(0, 5).map((target) => (
                            <img
                                key={target.channel.uuid}
                                className={"variantGroupCard__channel rounded-circle" + (target.state === 'assigned' ? " variantGroupCard__channel--picked" : "")}
                                src={getHandlerIconByCode(target.channel.network)}
                                alt={target.channel.name}
                                title={target.channel.name + (target.variant ? " · " + target.variant : "")}
                            />
                        ))}
                    </span>
                    <span className="variantGroupCard__progress">{picked}/{total}</span>
                </span>}
        </button>
    );
};

export default VariantGroupCard;
